export const types = {
    ROOT_RESET: 'ROOT_RESET',
};

const rootActions = {
    types,
    reset() {
        return { type: types.ROOT_RESET };
    },
};

export default rootActions;
